if (!customElements.get('shop-the-look')) {
  customElements.define('shop-the-look', class ShopTheLook extends HTMLElement {
    constructor() {
      super();

      this.image = this.querySelector('.stl_image');
      this.content = this.querySelector('.stl_content');
      this.productsContainer = this.querySelector('.stl_products');
      this.context = this.dataset.context;

      this.hotspots = this.querySelectorAll('.stl_hotspot');
      this.productCards = this.querySelectorAll('.stl_product');
    }

    connectedCallback() {
      if(this.context === 'section') {
        this.setContentHeight();
        this.image.addEventListener('load', () => {
          this.setContentHeight();
        });
        window.addEventListener('resize', () => {
          this.setContentHeight();
        });
      }

      this.hotspots.forEach(hotspot => {
        hotspot.addEventListener('mouseenter', () => {
          this.onHotspotHover(hotspot);
        });
        hotspot.addEventListener('mouseleave', () => {
          this.productCards.forEach(productCard => {
            productCard.classList.remove('active');
          });
        });
        hotspot.addEventListener('click', () => {
          this.onHotspotHover(hotspot);
        });
      });

      this.productCards.forEach(productCard => {
        productCard.addEventListener('mouseenter', () => {
          this.onCardHover(productCard);
        });
        productCard.addEventListener('mouseleave', () => {
          this.hotspots.forEach(hotspot => {
            hotspot.classList.remove('pulse');
          });
        });
      });
    }

    setContentHeight() {
      this.style.setProperty('--stl-content-height', this.image.clientHeight + 'px');
    }

    onHotspotHover(hotspot) {
      this.productCards.forEach(productCard => {
        if(productCard.dataset.productIndex === hotspot.dataset.productIndex) {
          productCard.classList.add('active');
        } else {
          productCard.classList.remove('active');
        }
      });
      // scroll to the product card
      if( window.innerWidth > 990 ) {
      this.scrollIntoViewDesktop(hotspot);
      } else {
        this.scrollIntoViewMobile(hotspot);
      }
    }

    onCardHover(productCard) {
      this.hotspots.forEach(hotspot => {
        if(productCard.dataset.productIndex === hotspot.dataset.productIndex) {
          hotspot.classList.add('pulse');
        } else {
          hotspot.classList.remove('pulse');
        }
      });
    }

    scrollIntoViewDesktop(hotspot) {
      const productCard = this.querySelector(`.stl_product[data-product-index="${hotspot.dataset.productIndex}"]`);
      const productCardTop = productCard.getBoundingClientRect().top;
      const productCardHeight = productCard.clientHeight;
      const productCardBottom = productCardTop + productCardHeight;

      const productsContainerTop = this.productsContainer.getBoundingClientRect().top;
      const productsContainerHeight = this.productsContainer.clientHeight;
      const productsContainerBottom = productsContainerTop + productsContainerHeight;

      if(productCardTop < productsContainerTop) {
        this.productsContainer.scrollTo({
          top: this.productsContainer.scrollTop + productCardTop - productsContainerTop,
          behavior: 'smooth'
        });
      } else if(productCardBottom > productsContainerBottom) {
        this.productsContainer.scrollTo({
          top: this.productsContainer.scrollTop + productCardBottom - productsContainerBottom,
          behavior: 'smooth'
        });
      }
    }

    scrollIntoViewMobile(hotspot) {
      const productCard = this.querySelector(`.stl_product[data-product-index="${hotspot.dataset.productIndex}"]`);
      const productCardLeft = productCard.getBoundingClientRect().left;
      const productCardWidth = productCard.clientWidth;
      const productCardRight = productCardLeft + productCardWidth;

      const productsContainerLeft = this.productsContainer.getBoundingClientRect().left;
      const productsContainerWidth = this.productsContainer.clientWidth;
      const productsContainerRight = productsContainerLeft + productsContainerWidth;

      if(productCardLeft < productsContainerLeft) {
        this.productsContainer.scrollTo({
          left: this.productsContainer.scrollLeft + productCardLeft - productsContainerLeft,
          behavior: 'smooth'
        });
      } else if(productCardRight > productsContainerRight) {
        this.productsContainer.scrollTo({
          left: this.productsContainer.scrollLeft + productCardRight - productsContainerRight,
          behavior: 'smooth'
        });
      }
    }


  });
}